import SgCaptcha from './SgCaptcha'
import SgPhoneConfirm from './SgPhoneConfirm'
import SgPhoneChangeForm from './SgPhoneChangeForm'

export default {

    props: {
        newUser: {
            type: Boolean,
            default: false,
            required: false
        },
        prePhone: {
            type: String,
            required: false
        },
        formMessage: {
            type: String,
            required: false
        },
        formShowCancel: {
            type: Boolean,
            required: false,
            default: false
        },
        formEluaWarning: {
            type: Boolean,
            required: false,
            default: false
        },
        formShowFeatures: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        hash() {
            return this.$route.hash
        },
        isHashMode() {
            return false
        }
    },
    data() {
        return {
            phone: this.prePhone,
            pin: '',
            captchaImage: '',
            captchaAnswer: '',
            loading: false,
            force: false,
            
            currentComponent: 'form'
        }   
    },
    methods: {

        onSend({
            phone,
            pin
        }) {
            this.phone = phone
            this.pin = pin
            this.phoneReg(phone)
        },

        showConfirm() {
     /*        if (window.location.hash == '#confirm') {
                this.$refs.confirm.focus()
            } else {
                window.location.hash = 'confirm'
            } */


            if (this.currentComponent == 'confirm') {
                this.$refs.confirm.focus()
            } else {
                this.currentComponent = 'confirm'
            }
        },

        showCaptcha(captchaImage) {
/*             if (window.location.hash == '#captcha') {
                this.$refs.captcha.focus()
            } else {
                window.location.hash = 'captcha'
            } */


            if (this.currentComponent == 'captcha') {
                this.$refs.captcha.focus()
            } else {
                this.currentComponent = 'captcha'
            }


            this.captchaImage = captchaImage
        },

        showAlreadyUseWarn() {
            this.$eventBus.$emit('modal:dialog', {
                dialogProps: {
                    noClickAnimation: true,
                    persistent: true,
                },
                props: {
                    message: "Введеный номер телефона уже используется Вами.",
                    acceptText: 'Ок',
                },
                listeners: {
                    accept: () => {
                        this.$nextTick(() => {
                            this.$refs.phone.focus()
                        })
                    }
                }
            })
        },

        askIgnore() {
            this.$eventBus.$emit('modal:dialog', {
                props: {

                    vertical: true,
                    message: "Данный номер телефона уже привязан к другой карте.",
                    acceptText: 'Ввести другой номер',
                    rejectText: 'Продолжить',
                },
                listeners: {
                    accept: () => {
                       this.$nextTick(() => {
                            this.$refs.phone.focus()
                        })
                    },
                    reject: () => {
                        this.force = true
                        this.phoneReg(this.phone)
                    }
                }
            })
        },

        phoneReg(phone, captcha) {


            captcha = captcha || ''
            let force = this.force

            this.loading = true

            this.$api.phoneReg(phone, captcha, force)
                .then(res => {
                    switch (res.status) {
                        case 0: {
                            this.showConfirm()
                            break;
                        }
                        case 1: {
                            this.showCaptcha(res.captcha)
                            break;
                        }
                        case 2: {
                            this.askIgnore()
                            break;
                        }
                        case 3: {
                            this.showAlreadyUseWarn()
                            break;
                        }
                    }
                })
                .catch(error => {
                    this.$logger.error('phoneReg: ', error)
                    this.$eventBus.$emit('error', error)
                })
                .finally(() => {
                    this.loading = false
                })
        },


        genCaptcha() {
            return this.$createElement(SgCaptcha, {
                props: {
                    captchaImage: this.captchaImage,
                    loading: this.loading
                },
                on: {
                    solve: answer => {
               /*          this.$router.back() */
                        this.phoneReg(this.phone, answer, true)
                    }
                },
                ref: 'captcha',
                key: 'captcha'
            })
        },

        genConfirm() {
            return this.$createElement(SgPhoneConfirm, {
                ref: 'confirm',
                props: {
                    phone: this.phone,
                },
                on: {
                    confirmed: () => {
                        if (this.newUser) {
                            this.$api.changePin(this.pin)
                                .then(res => {
                                    this.$emit('done')
                                })
                                .catch(error => {
                                    this.$eventBus.$emit('error', error)
                                })
                        } else {
                            this.$emit('done')
                        }
                    },
                    resend: () => {
                        this.phoneReg(this.phone, '', true)
                    },
                    back: () => {
                        this.currentComponent = 'form'
                    }
                },
                key: 'confirm'
            })
        },

        genPhoneForm() {

 /*            console.log("this.formShowCancel: ", !!this.formShowCancel) */

            return this.$createElement(SgPhoneChangeForm, {
                props: {
                    newUser: this.newUser,
                    prePhone: this.phone,
                    prePin: this.pin,
                    captchaAnswer: this.captchaAnswer,
                    loading: this.loading,
                    formMessage: this.formMessage,
                    showCancel: this.formShowCancel,
                    eluaWarning: this.formEluaWarning,
                    showFeatures: this.formShowFeatures
                },
                on: {
                    send: this.onSend,
                    cancel: () => {
                        this.$emit('cancel')
                    }
                },
                ref: 'phone',
                key: 'phone'
            })
        },

        
        genCurrentPage() {


            switch (this.currentComponent) {
                case 'captcha': {
                    return this.genCaptcha()
                }
    
                case 'confirm': {
                    return this.genConfirm()
                }
    
                default: {
                    return this.genPhoneForm()
                }
            }
        },

        genCurrentPage2() {


            switch (this.hash) {
                case '#captcha': {
                    return this.genCaptcha()
                }
    
                case '#confirm': {
                    return this.genConfirm()
                }
    
                default: {
                    return this.genPhoneForm()
                }
            }
        }

    },

    render(h) {


        return h('transition', {

            props: {
                name: "fade",
                mode: "out-in"
            }

        }, [this.genCurrentPage()])

        

    }

}